import { format } from 'date-fns';
import nl from 'date-fns/locale/nl';

export const convertString = (dateString?: string): Date | undefined => {
    if (dateString === undefined || dateString === '') {
        return undefined;
    }
    const dateArray = dateString.split('/');
    return new Date(parseInt(dateArray[2]), parseInt(dateArray[1]) - 1, parseInt(dateArray[0]));
};

export const convertDateToDutchString = (date?: Date): string | undefined => {
    if (!date) {
        return undefined;
    }
    return format(date, 'dd/MM/yyyy', { locale: nl });
};

export const convertStringToDutchString = (dateString?: string): string | undefined => {
    if (dateString === undefined || dateString === '') {
        return undefined;
    }
    return convertDateToDutchString(new Date(dateString));
};
